"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getUserPermissions = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var getUserPermissions = function getUserPermissions(state) {
  return _lodash.default.get(state, ['auth', 'user', 'scopePermissions'], []);
};
exports.getUserPermissions = getUserPermissions;
var _default = {};
exports.default = _default;